import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M18.75 5.25h-2.063a.188.188 0 01-.187-.188V3.75a.75.75 0 10-1.5 0v3.563a.563.563 0 01-1.125 0V5.625a.375.375 0 00-.375-.375H8.812a.187.187 0 01-.187-.188V3.75a.75.75 0 00-1.5 0v3.563a.563.563 0 11-1.125 0V5.625a.375.375 0 00-.375-.375H4.5A1.5 1.5 0 003 6.75V19.5A1.5 1.5 0 004.5 21h14.25a1.5 1.5 0 001.5-1.5V6.75a1.5 1.5 0 00-1.5-1.5zm0 13.875a.375.375 0 01-.375.375h-13.5a.375.375 0 01-.375-.375v-9a.375.375 0 01.375-.375h13.5a.375.375 0 01.375.375v9z",
      fill: "#333"
    }
  ),
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M15.114 11.36a1.133 1.133 0 00-1.193.136l-1.26 1.012a.75.75 0 00.93 1.17l.66-.525v4.095a.75.75 0 001.5 0v-4.875a1.126 1.126 0 00-.637-1.012zM9.563 11.25H7.875a.75.75 0 100 1.5h1.688a.563.563 0 010 1.125H9a.75.75 0 100 1.5h.563a.563.563 0 010 1.125H7.875a.75.75 0 100 1.5h1.688a2.062 2.062 0 001.59-3.375 2.062 2.062 0 00-1.59-3.375z",
      fill: "#333"
    }
  )
);
export {
  t as default
};
